import { forwardRef, type CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import s from './StepIndicator.module.scss';

interface StepIndicatorProps {
  step: number;
  total: number;
  label?: string;
  /** Classes to apply to wrapping div */
  className?: string;
}

const StepIndicator = forwardRef<HTMLDivElement, StepIndicatorProps>(
  ({ step, total, label = '', className = '' }, ref) => {
    const barWidth = (1 / total) * 100;
    const barOffset = ((step - 1) / total) * 100;

    const stepBarStyle: CSSProperties = {
      width: `${barWidth}%`,
      left: `${barOffset}%`,
    };
    if (step === total) {
      stepBarStyle.right = '0';
      delete stepBarStyle.width;
    }
    return (
      <div
        className={`${s.stepIndicator} ${className}`}
        tabIndex={-1}
        ref={ref}
      >
        <FormattedMessage id="stepindicator.step" /> {step}/{total}
        <div className={s.fullwidthbar} /> :{' '}
        <div className={s.stepbar} style={stepBarStyle} />
        {label}
      </div>
    );
  }
);

StepIndicator.displayName = 'StepIndicator';

export default StepIndicator;
